import loadable from '@loadable/component';
import FullPageLoader from '../../components/UIElements/Loader/fullPageLoader';
export const ListNotification = loadable(() => import('./List'), {
  fallback: <FullPageLoader />,
});
export * from './List';
